const items = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20explosive%20cinematic%20lighting%2C%20dramatic%20orange%20and%20teal%20color%20grading%2C%20hero%20silhouette%20against%20burning%20cityscape%2C%20intense%20atmosphere%2C%20film%20grain%20texture%2C%20widescreen%20composition%2C%20blockbuster%20movie%20poster%20style%20with%20high%20contrast%20and%20dynamic%20energy&width=600&height=400&seq=carousel-action-01&orientation=landscape',
    tag: '动作大片',
    title: '燃爆肾上腺素 · 动作电影特辑',
    desc: '精选全球顶级动作大片，高燃打斗场面、震撼视觉特效，带给你最极致的观影快感。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20suspense%20thriller%20cinematic%20scene%2C%20dark%20rainy%20alley%20with%20neon%20reflections%2C%20detective%20shadow%20under%20streetlamp%2C%20film%20noir%20aesthetic%2C%20deep%20blue%20and%20amber%20lighting%2C%20tense%20atmosphere%2C%20mysterious%20and%20brooding%20cinematic%20composition%20with%20grainy%20texture&width=600&height=400&seq=carousel-suspense-02&orientation=landscape',
    tag: '悬疑烧脑',
    title: '智商碾压 · 烧脑悬疑精选',
    desc: '高能反转不断，每一分钟都在挑战你的推理极限。悬疑迷不可错过的经典合集。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20and%20bright%20comedy%20film%20scene%2C%20colorful%20set%20design%20with%20playful%20props%2C%20cheerful%20characters%20in%20a%20lively%20living%20room%2C%20soft%20golden%20sunlight%20streaming%20through%20windows%2C%20feel%20good%20and%20joyful%20atmosphere%2C%20wholesome%20and%20funny%20movie%20poster%20aesthetic&width=600&height=400&seq=carousel-comedy-03&orientation=landscape',
    tag: '爆笑喜剧',
    title: '笑到停不下来 · 高分喜剧合集',
    desc: '解压神器，笑点密集，一个人看也能笑出声。治愈所有不开心的喜剧良药。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Romantic%20movie%20scene%20with%20couple%20silhouette%20against%20golden%20sunset%2C%20soft%20bokeh%20lights%2C%20warm%20pink%20and%20orange%20tone%2C%20dreamy%20atmosphere%2C%20vintage%20film%20aesthetic%2C%20emotional%20and%20tender%20cinematic%20composition%2C%20hearts%20floating%20subtly%20in%20the%20air%2C%20nostalgic%20romantic%20film%20poster%20style&width=600&height=400&seq=carousel-romance-04&orientation=landscape',
    tag: '浪漫爱情',
    title: '心动瞬间 · 浪漫爱情电影展',
    desc: '最动人的爱情故事，关于相遇、错过与重逢。每一帧都值得反复品味。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20science%20fiction%20movie%20scene%2C%20vast%20spaceship%20interior%20with%20holographic%20displays%2C%20neon%20blue%20and%20purple%20ambient%20lighting%2C%20astronaut%20looking%20at%20distant%20galaxy%20through%20massive%20window%2C%20epic%20scale%2C%20cinematic%20widescreen%2C%20atmospheric%20and%20immersive%2C%20sci-fi%20movie%20poster%20aesthetic&width=600&height=400&seq=carousel-scifi-05&orientation=landscape',
    tag: '科幻巨制',
    title: '畅游星辰大海 · 科幻电影盛宴',
    desc: '从太空史诗到时间穿越，想象力无边界的科幻经典，带你探索未知宇宙。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20film%20scene%20with%20cherry%20blossoms%20falling%20in%20a%20dreamy%20landscape%2C%20soft%20pastel%20color%20palette%2C%20hand%20drawn%20illustration%20style%2C%20magical%20atmosphere%20with%20sparkling%20lights%2C%20clouds%20in%20the%20sky%2C%20emotional%20and%20breathtaking%20animated%20movie%20aesthetic%2C%20Studio%20Ghibli%20inspired%20composition&width=600&height=400&seq=carousel-anime-06&orientation=landscape',
    tag: '动画精选',
    title: '治愈与冒险 · 精品动画电影',
    desc: '从吉卜力到迪士尼，跨越国界的动画艺术。适合全家一起观看的温情佳作。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading text-center">
          焦点专题
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          编辑精选六大主题，发现属于你的心头好
        </p>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((item, i) => (
            <article
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/50 transition-colors group"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) parent.style.display = 'flex';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}